import RpIcon from "@/components/RpIcon";
import { KYC_STATUS } from "@/constant/Constant";
import RouteConstant from '@/constant/RouteConstant';
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import { Box, CircularProgress, Stack } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AMLStatusBody from './components/AMLStatusBody';
import AMLStatusHeader from './components/AMLStatusHeader';
import KYCStatusBody from './components/KYCStatusBody';
import KYCStatusHeader from './components/KYCStatusHeader';
import classes from "./css/index.module.less";

function KYCIndex() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, loading } = useSelector(state => state.user);

  const _onKycPreInfo = () => {
    navigate(RouteConstant.KYC_PRE_FORM);
  }

  const _amlReject = () => {
    if (user?.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) return false;
    return user?.kycAmlReject == 1;
  }

  if (!user) return null;
  // 前置没有提交 理论上不会到这页
  if (user.hasSubmitKycPreInfo != 1) return null;

  if (loading['getUserInfo']) return <div style={{ margin: '0 auto', padding: '20vh' }}>
    <CircularProgress size={50}/>
  </div>;
  
  return (<>
    <SimpleHeader />
    <Box className={classes['kyc-wrap']}>
      <Box className={classes['kyc-status-info']}>
        {_amlReject() ? <AMLStatusHeader /> : <KYCStatusHeader />}
        {_amlReject() ? <AMLStatusBody /> : <KYCStatusBody />}
      </Box>
      {!_amlReject() && <Box className={classes['kyc-status-info']}>
        <p className={'small'}>{t('personnel_information_details')}</p>
        <Stack onClick={_onKycPreInfo} direction={'row'} justifyContent={'space-between'} alignItems={'center'} className={classes['kyc-page-redirect']}>
          <Stack direction={'row'} gap={'12px'}>
            <RpIcon icon={'id-card'} />
            <div className={"h5"}>{t('personal_info_review')}</div>
          </Stack>
          <RpIcon icon={'arrow-right-simple'} size={18}/>
        </Stack>
      </Box>}
    </Box>
  </>)
}

export default KYCIndex